import type {
  CreativeWorksCatalogItemApiResponse,
  CreativeWorksCatalogSearchApiResponse,
} from './interfaces';

const CREATIVE_WORKS_FETCH_TIMEOUT_MS = 10_000;

const fetchCatalogJson = async <T>(url: string): Promise<T> => {
  const controller = new AbortController();
  const timeoutId = setTimeout(
    () => controller.abort(),
    CREATIVE_WORKS_FETCH_TIMEOUT_MS
  );

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      signal: controller.signal,
    });
    if (!response.ok) {
      throw new Error(
        `Creative Works catalog API error: ${response.status} ${response.statusText}`
      );
    }
    return response.json() as Promise<T>;
  } catch (error) {
    if (error instanceof Error && error.name === 'AbortError') {
      throw new Error(
        `Creative Works catalog API request timed out after ${CREATIVE_WORKS_FETCH_TIMEOUT_MS}ms`
      );
    }
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }
};

const fetchCatalogItem = (
  url: string
): Promise<CreativeWorksCatalogItemApiResponse> =>
  fetchCatalogJson<CreativeWorksCatalogItemApiResponse>(url);

const fetchCatalogSearch = (
  url: string
): Promise<CreativeWorksCatalogSearchApiResponse> =>
  fetchCatalogJson<CreativeWorksCatalogSearchApiResponse>(url);

export const creativeWorksCatalogRequests = {
  fetchCatalogJson,
  fetchCatalogItem,
  fetchCatalogSearch,
};
